import React from "react";

function Signup() {
  return <div>hi</div>;
}

export default Signup;
